import { useQuery } from '@tanstack/react-query';

import { RESPONSE_ITEMS_PER_PAGE } from 'src/constants';
import { apiRequest } from 'src/helpers/apiRequest';
import { useAppConfig } from 'src/hooks';
import {
  ApplicationListResponse,
  TenantResponsePaginationItemsContainer,
} from 'src/types/rest/tenant';

interface UseTenantsProps {
  applicationListId?: ApplicationListResponse['id'];
  searchQuery?: string | null;
}

export const useTenants = ({
  applicationListId,
  searchQuery,
}: UseTenantsProps) => {
  const {
    tenancy: { apiHost },
  } = useAppConfig();

  return useQuery({
    queryFn: () =>
      apiRequest<TenantResponsePaginationItemsContainer>({
        url: `${apiHost}/tenants?PageIndex=1&ItemsPerPage=${RESPONSE_ITEMS_PER_PAGE}${applicationListId ? '&applicationListId=' + applicationListId : ''}${searchQuery ? '&query=' + searchQuery : ''}`,
      }),
    queryKey: ['tenants', applicationListId, searchQuery],
  });
};
